import useMyAccountHelper from "./helper";
import AeroSyncWidget from "../../components/aeropay-sdk";
import AccountListing from "../../components/table/account-listing";

const AccountModule = () => {
  const {
    openAeropaySDK,
    aeropaySDKToken,

    handleCloseAeropaySDK,
    handleAddAccountBtnClick,
  } = useMyAccountHelper();

  return (
    <div className="AccountListingWrapper">
      <div className="topView">
        <h2>My Accounts</h2>

        <button className="addBtn" onClick={handleAddAccountBtnClick}>
          Add New Account
        </button>
      </div>

      <div className="customTableWrapper">
        <AccountListing />
      </div>

      {openAeropaySDK && (
        <AeroSyncWidget
          token={aeropaySDKToken}
          handleClose={handleCloseAeropaySDK}
        />
      )}
    </div>
  );
};

export default AccountModule;
